import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import VideoGridSection from './components/VideoGridSection';
import ArticleSection from './components/ArticleSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import ScrollToTop from '@/components/base/ScrollToTop';

export default function HomePage() {
  const homeJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '黄瓜视频在线观看 - 免费高清视频播放平台',
    description: '黄瓜视频在线观看，提供海量高清视频内容，无需下载即可流畅播放。支持多终端访问，随时随地畅享优质视频资源。',
    url: 'https://huanggua.video',
    isPartOf: {
      '@type': 'WebSite',
      name: '黄瓜视频',
      url: 'https://huanggua.video',
    },
  };

  return (
    <>
      <SEOHead
        title="黄瓜视频在线观看 - 免费高清视频播放平台"
        description="黄瓜视频在线观看，提供海量高清视频内容，无需下载即可流畅播放。支持多终端访问，随时随地畅享优质视频资源，操作简单，加载迅速，立即体验黄瓜视频在线观看的极致流媒体服务。"
        keywords="黄瓜视频在线观看,黄瓜视频免费观看,黄瓜视频高清播放,在线视频观看平台,黄瓜视频手机观看,黄瓜视频最新内容,免费在线视频流媒体"
        canonicalUrl="https://huanggua.video"
        jsonLd={homeJsonLd}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <VideoGridSection />
        <ArticleSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}